export const CheckoutStates = {
  STARTED: 'STARTED',
  NOT_FINISHED: 'NOT_FINISHED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  NOT_INITIALIZED: 'NOT_INITIALIZED',
  INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
}
